function onTeamInviteAccepted(event) {
  if (+GT.user.id === +event.userData.id) {
    window.location.replace('/');
  }
}

export default onTeamInviteAccepted;
